import { MutationTree } from 'vuex';
import {
  TutorsState,
  Tutor,
  Group,
} from '@/store/tutors/types';
import _ from 'lodash';
import { Sort } from '@/store/sort.types';
import { Pager } from '../pager.types';

const mutations: MutationTree<TutorsState> = {
  fetchedTutors: (state, payload: {
    pager: Pager,
    tutors: Tutor[],
    sortBy: Sort
  }) => {
    // 日付のフォーマットを変換
    state.tutors = payload.tutors
    state.pager = payload.pager
    state.sort = payload.sortBy
  },

  gotTutor: (state, tutor: Tutor) => {
    // チューター情報を追加or上書き
    state.tutors = _.uniqBy([tutor, ...state.tutors], 'id')
  },

  fetchedTutorGroups: (state, { tutorId, groups }: { tutorId: string, groups: Group[] }) => {
    const tutor = _.chain(state.tutors)
      .find({ id: tutorId })
      .set('groups', groups)
      .value()

    state.tutors = _.uniqBy([
      tutor,
      ...state.tutors,
    ], 'id')
  },

  fetchedTraffic: (state, tutor: Tutor) => {
    const index = _.findIndex(state.tutors, { id: tutor.id });
    state.tutors.splice(index, 1, tutor);
  },
};

export default mutations;
